import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/lib/util/colors";
import "material-design-icons-iconfont/dist/material-design-icons.css";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "md"
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#4CAF50",
        secondary: "#504CAF",
        tertiary: "#AF504C",
        accent: "#4CAF50",
        error: colors.red
      },
      dark: {
        primary: "#25da41",
        secondary: "#4125DA",
        tertiary: "#DA4125"
      }
    }
  }
});
